import { createContext } from 'react';

export const WalletContext = createContext<{ openWallet: () => void } | null>(
  null
);
